import React from 'react';
import styles from './CustomDetails.module.scss';

export default function BreakLine() {
  return <hr className={styles.line} />;
}
